module.exports = __webpack_public_path__ + "img/hoc_vien.5fd5cfea.svg";